<template>
  <div v-show="value">
    <div class="mask"></div>
    <div class="fixed" @touchmove.prevent @mousewheel.prevent>
      <div class="popActivity-content" @click="close">
        <div style="position: relative;" @click.stop>
          <i @click="close" style="position: absolute;right: -25px;top: -25px;transform: scale(2);cursor: pointer;" class="el-icon-close"></i>
          <img src="../../common/img/ux_content.png" style="height: 500px;" />

          <div v-if="dialog.isNewMember" class="content-item1" @click="clickContent(1)">
            <span class="content-item-title">优惠券</span>
            <div class="content-item-divtext u-line-1">
              <div class="content-item-divtext-text1 u-line-1">新人体验券</div>
              <div class="content-item-divtext-text2 u-line-1">领取专属优惠券</div>
            </div>
          </div>

          <div v-else class="content-item1" @click="clickContent(1)">
            <span class="content-item-title">优惠券</span>
            <div class="content-item-divtext u-line-1">
              <div class="content-item-divtext-text1 u-line-1">专属优惠券</div>
              <div class="content-item-divtext-text2 u-line-1">领取专属优惠券</div>
            </div>
          </div>

          <div  v-if="actActivity.list[0]" class="content-item2" @click="openView(actActivity.list[0].url)">
            <span class="content-item-title">{{actActivity.list[0].tag}}</span>
            <div class="content-item-divtext u-line-1">
              <div class="content-item-divtext-text1 u-line-1">{{actActivity.list[0].title}}</div>
              <div class="content-item-divtext-text2 u-line-1">{{actActivity.list[0].summary}}</div>
            </div>
          </div>

          <div  v-if="actActivity.list[1]" class="content-item3" @click="openView(actActivity.list[1].url)">
            <span class="content-item-title">{{actActivity.list[1].tag}}</span>
            <div class="content-item-divtext u-line-1">
              <div class="content-item-divtext-text1 u-line-1">{{actActivity.list[1].title}}</div>
              <div class="content-item-divtext-text2 u-line-1">{{actActivity.list[1].summary}}</div>
            </div>
          </div>

          <div class="content-item4" @click="clickContent(4)"></div>
        </div>
      </div>
    </div>
    <el-dialog width="30%" :visible.sync="dialog.show" :lock-scroll="false">
      <!-- 联系客服 -->
      <img v-show="dialog.type == 1" style="width: 25vw;" src="../../common/img/ux_service.png" />
      <!-- 新人优惠券 -->
      <img v-show="dialog.type == 2" style="width: 18vw;height: 50vh;" src="https://umxh.xue2you.cn/file/80.png" />
      <!-- 老人优惠券 -->
      <img v-show="dialog.type == 3" style="width: 18vw;height: 50vh;" src="https://umxh.xue2you.cn/file/80.png" />
    </el-dialog>
  </div>
</template>
<script>
export default {
	components: {},
	props: {
    value:{
      type:Boolean,
      default:false,
    }
  },
	data() {
		return {
      dialog:{
        show:false,
        type:null,
        isNewMember:false,//是否是新会员
      },
      actActivity:{
        list:[],
        index:2,//只取前2
      }
    };
	},
	mounted() {
    let that = this;
    that.requestApi({
      method: "get",
      url: "/api/member/isMember",
      then(member) {
       if(member.data === 0 && member.standbyData === null){//member.data === 0 且 member.standbyData === null 则是新用户
        that.dialog.isNewMember = true;
       }
      }
    });
    that.getActActivityList();
  },
	destroyed() {},
	methods: {
    getActActivityList(){
      let that = this;
      let param = {
          pageIndex:1,
          pageSize:10,
          type:1,//那个地方用，1：移动端首页小广告
      }
      that.requestApi({
        method: "get",
        url: "/api/actActivity/list",
        data:param,
        then(res) {
          that.actActivity.list = res.data;
         }
      });
    },
    clickContent(type){
      if(type == 4){
        this.dialog.type = 1;
      }
      if(type == 1){
        if(this.dialog.isNewMember){
          this.dialog.type = 2;
        }else{
          this.dialog.type = 3;
        }
      }
      this.dialog.show = true;
    },
    openView(url){
      window.open(url)
    },
    close(){
      this.$emit('update:value',false)
    }
  }
};
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
}
.fixed {
  position: fixed;
  z-index: 101;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
.popActivity-content {
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.content-item-title {
  position: absolute;
  top: 0;
  left: 90px;
  color: #262626;
  letter-spacing: 2px;
}
.content-item-divtext {
  position: absolute;
  top: 30px;
  left: 25px;
  text-align: left;
  color: #fff;
  width: 155px;
  &-text1 {
    font-size: 15px;
    padding-bottom: 5px;
  }
  &-text2 {
    letter-spacing: 2px;
  }
}
.content-item1 {
  position: absolute;
  top: 110px;
  left: 42px;
  height: 80px;
  width: 223px;
  cursor: pointer;
}
.content-item2:extend(.content-item1) {
  top: 214px;
}
.content-item3:extend(.content-item1) {
  top: 316px;
}
.content-item4:extend(.content-item1) {
  top: 420px;
  height: 60px;
}
/deep/ .el-dialog {
  background: transparent;
  box-shadow: none;
}
/deep/ .el-dialog__headerbtn .el-dialog__close{
  transform: scale(1.7);
}
</style>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/popActivity/popActivity.vue